/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getTransactionDocuments,
    getTransactionDocument,
    printTransactionDocument,
    createTransactionDocuments,
    updateTransactionDocuments,
    deleteTransactionDocuments,
} from "Modules/transaction_documents/config/api.transaction_documents";

const state = {
    page: {},
    form: {},
    transaction_documents: [],
    transaction_document_options: [],
    selectedTransactionDocument: {
        document_id: null,
        company_id: "",
        transaction_document_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        transaction_document_details: [],
    },
    transaction_documents_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_transaction_documents: {
        document_id: {
            name: "document_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        document_type: {
            name: "document_type",
            rules: "trim|max_length[15]",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        device_id: {
            name: "device_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        billing_address_id: {
            name: "billing_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        shipping_address_id: {
            name: "shipping_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        ship_location_label: {
            name: "ship_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_address1: {
            name: "ship_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_address2: {
            name: "ship_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_city: {
            name: "ship_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        ship_state: {
            name: "ship_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_zip_code: {
            name: "ship_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        ship_zip_code_ext: {
            name: "ship_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        ship_country_iso_3: {
            name: "ship_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        bill_location_label: {
            name: "bill_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_address1: {
            name: "bill_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_address2: {
            name: "bill_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_city: {
            name: "bill_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        bill_state: {
            name: "bill_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_zip_code: {
            name: "bill_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        bill_zip_code_ext: {
            name: "bill_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        bill_country_iso_3: {
            name: "bill_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        shipping_carrier_id: {
            name: "shipping_carrier_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        document_date: {
            name: "document_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        due_date: {
            name: "due_date",
            rules: "trim|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        payment_term_id: {
            name: "payment_term_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        approved: {
            name: "approved",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        exchange_rate: {
            name: "exchange_rate",
            rules: "trim|max_length[19]|decimal|required",
            max_len: "18",
            min_len: "",
            default_value: "1.000000",
        },
        status_id: {
            name: "status_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "20",
        },
        work_order_no: {
            name: "work_order_no",
            rules: "trim|max_length[20]",
            max_len: "20",
            min_len: "",
            default_value: "",
        },
        subtotal: {
            name: "subtotal",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        discount: {
            name: "discount",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        discount_type: {
            name: "discount_type",
            rules: "trim|max_length[1]|required",
            max_len: "1",
            min_len: "",
            default_value: "A",
        },
        freight: {
            name: "freight",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        expedite_fee: {
            name: "expedite_fee",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        handling_charge: {
            name: "handling_charge",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        customs: {
            name: "customs",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        total_amount: {
            name: "total_amount",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        balance: {
            name: "balance",
            rules: "trim|max_length[13]|decimal|required",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        document_subtotal: {
            name: "document_subtotal",
            rules: "trim|max_length[13]|decimal|required",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        document_discount: {
            name: "document_discount",
            rules: "trim|max_length[13]|decimal|required",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        document_freight: {
            name: "document_freight",
            rules: "trim|max_length[13]|decimal|required",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        document_expedite_fee: {
            name: "document_expedite_fee",
            rules: "trim|max_length[13]|decimal|required",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        document_handling_charge: {
            name: "document_handling_charge",
            rules: "trim|max_length[13]|decimal|required",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        document_customs: {
            name: "document_customs",
            rules: "trim|max_length[13]|decimal|required",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        document_total_amount: {
            name: "document_total_amount",
            rules: "trim|max_length[13]|decimal|required",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        customer_po: {
            name: "customer_po",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        comments: {
            name: "comments",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        department_id: {
            name: "department_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        transaction_document_details: {
            product_id: {
                name: "product_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            quantity: {
                name: "quantity",
                rules: "trim|max_length[13]|decimal|required",
                max_len: "12",
                min_len: "",
                default_value: "",
            },
        },
    },
};

// getters
const getters = {
    transaction_documents: (state) => {
        return state.transaction_documents;
    },
};

// actions
const actions = {
    async fetchTransactionDocuments({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getTransactionDocuments({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "transaction_document_options",
                        with: response.data.transaction_documents,
                    });
                } else {
                    commit("mutate", {
                        property: "transaction_documents",
                        with: response.data.transaction_documents,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log(error);
            console.log("fetch all error");
            return;
        }
    },
    async fetchTransactionDocument({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getTransactionDocument(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedTransactionDocument",
                    with: response.data.transaction_document,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printTransactionDocument({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printTransactionDocument(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveTransactionDocument({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["document_id"] === "undefined" || body["document_id"] == null || body["document_id"] == "") {
                delete body["document_id"];
                response = await createTransactionDocuments({ body: body, headers: config.headers });
            } else {
                let document_id = body["document_id"];
                delete body["document_id"];
                response = await updateTransactionDocuments({ body: body, headers: config.headers }, document_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteTransactionDocument({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteTransactionDocuments(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
